export const GET_CREDIT_CARD_OPTION_START =
  'GET_CREDIT_CARD_OPTION_START';
export const GET_CREDIT_CARD_OPTION_SUCCESS =
  'GET_CREDIT_CARD_OPTION_SUCCESS';
export const GET_CREDIT_CARD_OPTION_ERROR =
  'GET_CREDIT_CARD_OPTION_ERROR';
export const GET_CREDIT_CARD_OPTION_END =
  'GET_CREDIT_CARD_OPTION_END';
